module.exports = __webpack_public_path__ + "static/img/portal_logo.10a625d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portal_logo.png
// module id = XTJa
// module chunks = 2